export interface IEntiteDonnee {
    id?: string;
    champId: string;
    primaryId?: string;
    valeur: string;
}

export class EntiteDonnee implements IEntiteDonnee {

    id?: string;
    champId: string;
    primaryId?: string;
    valeur: string;

    public constructor(entiteDonnee: IEntiteDonnee) {
        this.id = entiteDonnee.id;
        this.champId = entiteDonnee.champId;
        this.primaryId = entiteDonnee.primaryId;
        this.valeur = entiteDonnee.valeur;
    }

    static fromJson(data: any): EntiteDonnee {
        return new EntiteDonnee({
            id: data.edo_id,
            champId: data.edo_chp_id,
            primaryId: data.edo_primary_id,
            valeur: data.edo_valeur
        });
    }

    toJson() {
        return {
            edo_id: this.id,
            edo_chp_id: this.champId,
            edo_primary_id: this.primaryId,
            edo_valeur: this.valeur
        };
    }
}

